import {
  AppSyncFarm,
  AppSyncFarmToken,
  MonitorVaults,
} from 'common/models/farm';
import React from 'react';
import Image from 'common/components/Image';
import { ScreenUtils } from 'utils/screenUtils';
import { AppSyncUserInfo } from 'common/models/userInfo';
import { TokenUtils } from 'utils/tokenUtils';
import { ChainId, YOUR_DEPOSITS_TABLE } from 'constants/constants';
import Tooltip from '../Tooltip/Tooltip';
import { TokenIcon } from '../TokenIcons/TokenIcon';
import UserDepositsPosition from './UserDepositsPosition';
import { ArchiveProtocolButton } from '../LinkButton/ArchiveProtocolButton';

type Props = {
  token: AppSyncFarmToken;
  farms: AppSyncFarm[];
  userInfoLoading: boolean;
  userInfo: AppSyncUserInfo;
  chainId?: ChainId;
  claiming: boolean;
  isIchiVault: boolean;
  monitorVaults: MonitorVaults[] | [];
  selectedTokenAddress: string;
};

const UserDepositsGroup: React.FC<Props> = (props) => {
  const breakpoint = ScreenUtils.useBreakpoint();

  const baseToken = props.token;

  const isEthVault =
    baseToken?.displayName === 'wETH' && props.chainId !== ChainId.Polygon &&
    props.chainId !== ChainId.Celo;
  const baseTokenDisplayName = isEthVault ? 'ETH'
    : (baseToken?.displayName === 'ETHC' ? 'ETH': baseToken?.displayName);
  const farms = props.farms;
  const table = YOUR_DEPOSITS_TABLE;

  // don't show tokens with 0 deposits
  const totalDeposits = farms.reduce((total, curr) => {
    return total + TokenUtils.getFarmUserInfo(curr, props.userInfo).totalLPUSD;
  }, 0);
  if (totalDeposits === 0 && !props.selectedTokenAddress) {
    return null;
  }

  const headers = table.headers.filter((h) => h.displayOn.includes(breakpoint));
  return (
    <div
      className="bordered flex flex-col justify-start items-start px-3 tablet:px-10 py-5 tablet:py-8 rounded-[10px] mb-4 shadow-md"
      key={`dtoken-${baseToken.address}`}
    >
      {/* Deposit Token */}
      <div className='flex flex-row justify-between w-full'>
        <div className="primary-text-color flex flex-row justify-betstartween items-center gap-3 font-semibold text-xl">
          <TokenIcon name={baseToken.name} height="50px" />
          {baseTokenDisplayName}
        </div>
        <ArchiveProtocolButton />
      </div>
      <table className="mt-4 mb-0">
        <thead>
          <tr className="table-border-bottom text-left sub-text-color text-sm">
            {headers.map((header, index) => (
              <th key={`user-deposits-${index}`}>
                <div className="flex flex-row">
                  <div className={index === 0 ? 'pl-5 mr-5' : 'mr-5'}>
                    {header.name}
                  </div>
                  {header.helpText && (
                    <div className="tooltip-wrapper">
                      <Tooltip
                        message={header.helpText}
                        position={header.name === 'Farm' ? 'right' : 'top'}
                        bubbleSize={{ width: '180px' }}
                      >
                        <Image className="icon-help" alt={header.helpText} />
                      </Tooltip>
                    </div>
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.farms.map((v) => (
            <UserDepositsPosition
              farm={v}
              key={`user-deposits-${v.poolId}`}
              userInfoLoading={props.userInfoLoading}
              userInfo={props.userInfo}
              claiming={false}
              monitorVaults={props.monitorVaults}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserDepositsGroup;
